// Runtime config takes precedence over build config; the legacy defaults remain
// compatible with existing installs. Staging must provide its isolated API URL.
export function resolveApiBaseURL(hostname, runtimeURL, buildURL) {
  const configured = String(runtimeURL || buildURL || '').trim();
  if (configured) return configured;
  return hostname === 'localhost' || hostname === '127.0.0.1'
    ? 'http://localhost:5050'
    : 'https://student-main-server-production.up.railway.app';
}
